
<template>
  <div class="gallery-text-component" ref="html-component">
    <div class="wrapper grid-x grid-margin-x" :class="['align-'+payload.vAlign]">
      <SliderGalleryComponent
        :class="[payload.alignment]"
        class="images-wrapper cell large-6"
        :payload="payload"
      ></SliderGalleryComponent>
      <div class="text-wrapper cell large-6" :class="[payload.hAlign, payload.alignment]">
        <p v-if="payload.title" class="h2 title">{{payload.title}}</p>
        <div
          class="text-content"
          v-if="payload.text"
          :class="[payload.dimension, payload.hAlign]"
          v-html="payload.text"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import SliderGalleryComponent from "@partials/SliderGalleryComponent";

export default {
  props: {
    payload: {
      default: {}
    }
  },
  components: {
    SliderGalleryComponent
  },
  mounted() {
    this.initListener();
  },
  methods: {
    initListener() {
      this.$refs["html-component"].addEventListener("click", e => {
        if (e.target && e.target.nodeName === "A") {
          let href = e.target.getAttribute("href");
          if (href.slice(0, 4) === "http") {
            return;
          }
          e.preventDefault();
          this.$router.push(href);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.gallery-text-component {
  @include breakpoint(medium down) {
    text-align: left !important;
  }
  .title {
    font-weight: 700;
    & + .text-content{
      margin-top: 32px;
    }
  }
  .images-wrapper {
    &.text-left {
      order: 2;
    }
    &.text-right {
      order: 1;
    }
  }

  .text-wrapper {
    &.text-left {
      order: 1;
    }
    &.text-right {
      order: 2;
    }

    margin-top: 64px;
    margin-bottom: 64px;
    @include breakpoint(medium down) {
      margin-top: 32px;
      margin-bottom: 32px;
    }

    &.left {
      text-align: left;
    }
    &.center {
      text-align: center;
    }
    &.right {
      text-align: right;
    }
  }

  .text-content {
    &.left {
      text-align: left;
    }
    &.center {
      text-align: center;
    }
    &.right {
      text-align: right;
    }

    &.medium {
      /deep/ * {
        font-size: 24px;
        line-height: 28px;
      }
    }
    &.bigger {
      /deep/ * {
        font-size: 32px;
        line-height: 36px;
      }
    }
    &.title {
      /deep/ * {
        font-size: 42px;
        line-height: 42px;
        font-weight: $global-weight-bold;
      }
    }

    /deep/ * {
      font-size: 18px;
      line-height: 24px;
      font-weight: $global-weight-normal;
    }
    /deep/ b,
    /deep/ strong {
      font-weight: $global-weight-bold;
    }
    /deep/ a {
      font-weight: $global-weight-bold;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
